import { z } from 'zod'

import { lenientList } from '@/schemas/common'

/**
 * The rail's "Shares unlocking soon": promoter and mutual-fund shares whose lock-in ends soon,
 * soonest first.
 *
 * PROPOSED contract, not a live one: mm-be carries no lock-in data (an `auction` event is a sale,
 * not a release). See `mm-homex-2026-10-28/asks/rail.md`; `shareUnlocksService` holds the single
 * switch that turns the request on.
 */

export const shareHolderSchema = z.enum(['promoter', 'mutual_fund'])

export const shareUnlockSchema = z.object({
  symbol: z.string().min(1),
  /** The company's name, for the row's tooltip. */
  name: z.string().min(1),
  /** The first day the shares can be sold, AD, `YYYY-MM-DD`. */
  unlockDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  /** Shares (kitta) coming free: a count, never a rupee figure. */
  quantity: z.number().int().positive(),
  holder: shareHolderSchema,
})

export const shareUnlocksSchema = lenientList(shareUnlockSchema, 'share unlock')

export type ShareHolder = z.infer<typeof shareHolderSchema>
export type ShareUnlock = z.infer<typeof shareUnlockSchema>
